
import { Component, Prop, Vue } from "vue-property-decorator";
import { AsyncComponentFactory } from "vue/types/options";
import { newState } from "../scenes/models";
import Modal from '../components/Modal.vue';

const componentSettings = {
  // loading: Loading,
  delay: 200,
};

const delay = (ms: number) => new Promise(res => setTimeout(res, ms));


@Component<any>({components: {Modal}})
export default class App extends Vue {
  setSound(sound: boolean) {
    localStorage.sound = sound
  }

  showRestart = false;
  hasState = !!localStorage.state
  
  restart() {
    localStorage.clear()
    location.reload();
  }
}
